/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Legajox_Ingest_Approval_DeniedInputs */

const es_components_legajox_ingest_approval_denied = /** @type {(inputs: Components_Legajox_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta de Legajox denegada`)
};

const en_components_legajox_ingest_approval_denied = /** @type {(inputs: Components_Legajox_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox ingestion denied`)
};

/**
* | output |
* | --- |
* | "Legajox ingestion denied" |
*
* @param {Components_Legajox_Ingest_Approval_DeniedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_legajox_ingest_approval_denied = /** @type {((inputs?: Components_Legajox_Ingest_Approval_DeniedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Legajox_Ingest_Approval_DeniedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_legajox_ingest_approval_denied(inputs)
	return en_components_legajox_ingest_approval_denied(inputs)
});
export { components_legajox_ingest_approval_denied as "components.legajox_ingest_approval.denied" }